type Task = {
  name: string
  taskId: string
  taskTypeTag: string
}

type AggregatedData = {
  [key: string]: number
}

// Function to aggregate data by taskTypeTag
const aggregateDataByTag = (data: Task[]): AggregatedData => {
  const aggregatedData: AggregatedData = {}

  data.forEach((item) => {
    const tag = item.taskTypeTag.trim() === "" ? "No Tags" : item.taskTypeTag
    if (aggregatedData[tag]) {
      aggregatedData[tag]++
    } else {
      aggregatedData[tag] = 1
    }
  })

  return aggregatedData
}

// Prepare chart data for Google Charts
export const prepareChartData = (data: Task[]): (string | number)[][] => {
  const aggregatedData = aggregateDataByTag(data)
  const chartData: (string | number)[][] = [["Task Type Tag", "Count"]]

  Object.entries(aggregatedData).forEach(([tag, count]) => {
    chartData.push([tag, count])
  })

  return chartData
}
